import { computed, Directive, input } from '@angular/core';
import { BrnDialogClose } from '@spartan-ng/brain/dialog';
import { hlm } from '@spartan-ng/helm/utils';
import type { ClassValue } from 'clsx';

@Directive({
  selector: 'button[hlmDialogClose]',
  hostDirectives: [{ directive: BrnDialogClose, inputs: ['delay'] }],
  host: {
    'data-slot': 'dialog-close',
    '[class]': '_computedClass()',
  },
})
export class HlmDialogClose {
  public readonly userClass = input<ClassValue>('', { alias: 'class' });

  protected readonly _computedClass = computed(() =>
    hlm(
      'absolute right-sm top-sm rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-accent',
      this.userClass(),
    ),
  );
}
